














import Vue from 'vue'

import { EventService } from '../../../base/services/EventService'

export default Vue.extend({
  props: {
    breadcrumbs: {
      type: Array,
      required: true,
      default: []
    }
  },
  methods: {
    onSelectBreadcrumb(wbUUID) {
      EventService.$emit('widget-select-by-uuid', wbUUID)
    }
  }
})
